module.exports = __webpack_public_path__ + "img/7.9bd2b385.jpg";